<template>
  <div class="content-box" v-if="show">
    <div class="content bg">
      <img class="img-title" :src="require(`../assets/${targetFolder}/audiovisual/audio_title.png`)" />
      <div class="specific">
        <div class="specific-content bg">
          <img @click="closeDialog" class="close" :src="require(`../assets/${targetFolder}/audiovisual/close.png`)" />
          <div class="content-title">
            <img class="checked"
            @click="checked=2"
            :src="checked === 2 ? require(`../assets/${targetFolder}/audiovisual/checked1.png`) : require(`../assets/${targetFolder}/audiovisual/unchecked1.png`)"  />
            <img class="cd" :src="require(`../assets/${targetFolder}/audiovisual/cd.png`)" />
            <img class="checked"
             @click="checked=1"
            :src="checked === 1 ? require(`../assets/${targetFolder}/audiovisual/checked2.png`) : require(`../assets/${targetFolder}/audiovisual/unchecked2.png`)"  />
          </div>
          <template>
            <ul>
              <li v-for="item in list" :key="item.id" @click="openMark(item)">
                <div v-if="checked===2" class="black-mark"></div>
                <img v-if="checked===2" class="play" :src="require(`../assets/${targetFolder}/audiovisual/play.png`)" />
                <img v-if="checked===2" class='img-content' :src="item.wap" />
                <img v-else class='img-content' :src="isDesktop ? item.pc :item.wap" />
              </li>
            </ul>
          </template>
           <template v-if="list.length > 0">
            <img @click="prev" class="prev" :src="require(`../assets/${targetFolder}/audiovisual/prev.png`)" />
            <img @click="next" class="next" :src="require(`../assets/${targetFolder}/audiovisual/next.png`)" />
            <div id="page" class="page-box">
              <div class="pagination">
              <img
                  @click="prev"
                  class="page-prev" :src="require(`../assets/${targetFolder}/audiovisual/lt.png`)" />
                <template>
                  <span
                    class="num"
                    :class="{
                      active: item === page.current
                    }"
                    v-for="item in pager"
                    @click="page.current = item"
                    :key="item">{{item}}</span>
                </template>
                <img
                  @click="next"
                  class="page-next" :src="require(`../assets/${targetFolder}/audiovisual/gt.png`)" />
              </div>
              <span class="tip">
                共&nbsp;{{totalPage}}&nbsp;页
              </span>
            </div>
          </template>
        </div>
        <img class="record" :src="require(`../assets/${targetFolder}/audiovisual/record.png`)" />
        <img v-if="isDesktop" class="camera" :src="require(`../assets/${targetFolder}/audiovisual/camera.png`)"  />
        <img v-if="isDesktop" class="headset" :src="require(`../assets/${targetFolder}/audiovisual/headset.png`)"  />
      </div>
      <div class="mark" v-if="markShow" @click="markShow = false"></div>
      <template v-if="markShow">
        <div class="dialog-content" :class="!isDesktop && checked === 2 ? 'mobile-video':''" @click="markShow = false">
          <img v-if="checked === 2" @click="markShow = false" class="close" :src="require(`../assets/${targetFolder}/audiovisual/close.png`)" >
          <template v-if="checked === 2">
            <videoPlayer
                ref="videoPlayer"
                @click.native.stop
                class="video"
                :style="{
                  width: '100%',
                  height:'100%'
                }"
                :options="playerOptions"
                @onError="onError"
            />
          </template>
          <template v-else>
            <div class="img-box">
              <img :src="checkedImg" @click="markShow = false"/>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  getWebSiteContent
} from '@/api'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
  name: 'AudioVisual',
  components: { videoPlayer },
  data () {
    return {
      show: false,
      markShow: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        controls: true,
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4',
            src: 'https://store.acngames.com/uploads/video/pages/202211/30/vfGzD0cZhzh5EeYSrYMJie5oG21scsrDFDwQ55n7.mp4'
          }
        ],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请返回下载。' // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        // controlBar: {
        //   timeDivider: true, // 当前时间和持续时间的分隔符
        //   durationDisplay: true, // 显示持续时间
        //   remainingTimeDisplay: false, // 是否显示剩余时间功能
        //   fullscreenToggle: true // 是否显示全屏按钮
        // }
      },
      checked: 2,
      page: {
        total: 25,
        current: 1,
        per_page: window.device.type === 'desktop' ? 4 : 2
      },
      list: [],
      checkedImg: ''
    }
  },
  computed: {
    targetFolder () {
      return this.$store.state.targetFolder
    },
    isDesktop () {
      return this.$store.state.isDesktop
    },
    totalPage () {
      const total = Math.ceil(this.page.total / this.page.per_page)
      // eslint-disable-next-line no-self-compare
      return total === total ? total : 1
    },
    pager () {
      const current = this.page.current
      const arr = [current]
      const totalPage = this.totalPage
      if (totalPage < 4) {
        const arr = []
        for (let index = 1; index <= totalPage; index++) {
          arr.push(index)
        }
        return arr
      }
      let f = false
      if (current + 3 > totalPage) {
        f = true
        if (current + 1 <= totalPage) {
          arr.push(current + 1)
        }
        if (current + 2 <= totalPage) {
          arr.push(current + 2)
        }
        if (current + 3 <= totalPage) {
          arr.push(current + 3)
        }
      } else {
        if (current - 1 > 0) {
          arr.unshift(current - 1)
        }
        if (current - 2 > 0) {
          arr.unshift(current - 2)
        }
        if (current - 3 > 0) {
          arr.unshift(current - 3)
        }
      }
      const loop = 3 - arr.length
      for (let index = 1; index <= loop; index++) {
        if (f) {
          arr.unshift(current - index)
        } else {
          arr.push(current + index)
        }
      }
      // console.log(arr)
      return arr
    }

  },
  watch: {
    'page.current' (v) {
      this.getWebSiteContent()
    },
    'checked' (v) {
      if (v) {
        this.checked = v
        if (this.page.current > 1) {
          this.page.current = 1
        } else {
          this.getWebSiteContent()
        }
      }
    }
  },
  mounted () {

  },
  created () {
    require(`../styles/${this.targetFolder}/audiovisual.scss`)
  },
  methods: {
    closeDialog () {
      this.show = false
      this.$emit('closeDialog')
    },
    openMark (item) {
      if (this.checked === 2) {
        this.playerOptions.poster = item.wap
        this.playerOptions.sources[0].src = item.pc
      } else {
        this.checkedImg = this.isDesktop ? item.pc : item.wap
      }
      this.markShow = true
    },
    onError () {
      console.log('视频报错了')
    },
    prev () {
      if (this.page.current > 1) {
        this.page.current--
      }
    },
    next () {
      if (this.page.current < this.totalPage) {
        this.page.current++
      }
    },
    // 新版官网获取数据
    async getWebSiteContent (value) {
      try {
        const params = {
          type: 2,
          per_page: this.page.per_page,
          mtype: this.checked,
          page: this.page.current
        }
        const { data } = await getWebSiteContent(params)
        this.page.total = data.total
        this.list = data.data
        // this.isLoading = true
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .video-js:hover .vjs-big-play-button {
  background-color:transparent;
}
::v-deep .vjs-big-play-button{
    width: 95px;
    height: 95px;
    border: none;
    background-image: url('../assets/mobile/audiovisual/play.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-color:transparent;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
